"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validations = exports.validateOtherInput = exports["default"] = void 0;
require("core-js/modules/es.array.find.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _checkboxGroup = _interopRequireDefault(require("./checkboxGroup"));
var _components = require("../../components");
var _lodash = _interopRequireDefault(require("lodash"));
var _validations2 = require("../../validations");
var _excluded = ["submitting", "fieldSpacing", "ComponentWrapper", "dispatch", "config", "with_none"],
  _excluded2 = ["other", "required"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var singleCheckboxProps = ['label', 'inputStyle', 'labelStyle', 'name', 'disabled', 'input', 'meta', 'options'];
var Checkbox = function Checkbox(_ref) {
  var submitting = _ref.submitting,
    fieldSpacing = _ref.fieldSpacing,
    ComponentWrapper = _ref.ComponentWrapper,
    dispatch = _ref.dispatch,
    config = _ref.config,
    with_none = _ref.with_none,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var other_label = props.other_label;
  var otherLabel = _lodash["default"].isEmpty(other_label) ? 'Other' : other_label;
  if (!props.options || _lodash["default"].isEmpty(props.options)) {
    var passProps = _lodash["default"].pick(props, singleCheckboxProps);
    return /*#__PURE__*/_react["default"].createElement(_components.CheckboxInput, (0, _extends2["default"])({}, passProps, {
      config: _objectSpread(_objectSpread({}, passProps), _lodash["default"].pick(config, singleCheckboxProps))
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_checkboxGroup["default"], (0, _extends2["default"])({}, props, {
    otherLabel: otherLabel,
    config: _objectSpread(_objectSpread(_objectSpread({}, props), config), {}, {
      withNone: with_none
    })
  }));
};
var validations = exports.validations = function validations(_ref2) {
  var other = _ref2.other,
    required = _ref2.required,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _validations = [];
  if (other) _validations.push(validateOtherInput);
  if ((!props.options || _lodash["default"].isEmpty(props.options)) && required) _validations.push(_validations2.singleCheckboxMustBeChecked);
  return _validations;
};
var validateOtherInput = exports.validateOtherInput = function validateOtherInput(v) {
  var other = _lodash["default"].find(v, function (o) {
    return o.answer === 'other';
  });
  if (v && other) {
    if (!_lodash["default"].has(other, 'user_value') || _lodash["default"].isEmpty(other.user_value)) return 'please enter a value for other';
  }
};
Checkbox.handlesOwnError = true;
Checkbox.displayWarningSign = false;
var _default = exports["default"] = Checkbox;